import {
  aboutUs,
  authentication,
  authenticity,
  cart,
  charitableGiving,
  contactUs,
  customerService,
  designer,
  designerList,
  ipForm,
  main,
  press,
  privacy,
  productDetail,
  productList,
  resetMyPassword,
  reviews,
  terms
} from './metadata';

const metadata = {
  aboutUs,
  authentication,
  authenticity,
  cart,
  charitableGiving,
  contactUs,
  customerService,
  designer,
  designerList,
  ipForm,
  main,
  press,
  privacy,
  productDetail,
  productList,
  resetMyPassword,
  reviews,
  terms
};

export default metadata;
